type Rates = Record<string, number>;
type CacheEntry = { ts: number; rates: Rates };

const cache = new Map<string, CacheEntry>();
const TTL_MS = 6 * 60 * 60 * 1000;

const isFresh = (ts: number) => Date.now() - ts < TTL_MS;

export async function getFxRate(from: string, to: string): Promise<number> {
    const f = (from || '').toUpperCase();
    const t = (to || '').toUpperCase();
    if (!f || !t || f === t) return 1;

    const normFrom = f === 'GBX' ? 'GBP' : f;
    const normTo = t === 'GBX' ? 'GBP' : t;
    if (normFrom === normTo) return 1;

    const key = normFrom;
    const cached = cache.get(key);
    if (cached && isFresh(cached.ts) && cached.rates[normTo]) return cached.rates[normTo];

    const url = `https://open.er-api.com/v6/latest/${encodeURIComponent(normFrom)}`;
    const res = await fetch(url);
    if (!res.ok) return 1;

    const json = await res.json();
    const rates: Rates = json?.rates || {};
    cache.set(key, { ts: Date.now(), rates });

    return rates[normTo] ?? 1;
}
